import { PropsWithChildren } from 'react';

import { useQuestionExamGradeCtx } from '@/data/context/QuestionExamGradeContext';
import { VersioningProvider } from '@/data/context/VersioningContext';
import { updateExamActivity } from '@/data/services/examActivityServices';
import Activity from '@/models/Activity';

type ExamActivityVersioningProviderProps = PropsWithChildren<{
  activity: Activity;
  examAreaId: number;
  onVersioned?: (versioned: Activity, previous: Activity) => void;
}>;

export function ExamActivityVersioningProvider({
  activity,
  examAreaId,
  onVersioned,
  children,
}: ExamActivityVersioningProviderProps) {
  const grade = useQuestionExamGradeCtx();

  return (
    <VersioningProvider
      model={activity}
      createVersion={activityId =>
        updateExamActivity(examAreaId, activityId, {})
      }
      onVersioned={(versioned, previous) => {
        grade?.refetch().catch(() => undefined);
        onVersioned?.(versioned, previous);
      }}
    >
      {children}
    </VersioningProvider>
  );
}
